export default {
    methods:{
        parseErrorsToString(errors){
            let string = '';
            for (let error in errors.errors){
                string += errors.errors[error] + "<br>";
            }
            return string;
        },
        showSuccessNotification(text, title = 'Success'){
            this.$notify({
                group: 'event',
                title,
                text,
                type: 'success'
            });
        },
        showErrorNotification(error, title = 'Error') {
            let text = '';
            if (error.response && error.response.data) text = this.parseErrorsToString(error.response.data);
            if (!text && error.response.data.status && error.response.data.message) text = error.response.data.message;
            if (!text && error.request && error.request.status && error.request.statusText) text = error.request.status + ' ' + error.request.statusText;
            if (!text && typeof error === 'string' ) text = error;
            if (!text) text = 'Undefined Error';
            this.$notify({
                group: 'event',
                title: title,
                text,
                type: 'error'
            });
        },
        showErrorNotificationText(text, title = 'Error') {
            this.$notify({
                group: 'event',
                title,
                text,
                type: 'error'
            });
        },
        showWarningNotification(text){
            this.$notify({
                group: 'event',
                title: 'Attention',
                text,
                type: 'warn'
            });
        },
        showMessageNotification(text){
            this.$notify({
                group: 'event',
                title: 'Message',
                text,
                type: 'message'
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/notifications.js